/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { EARLY_PAYOUT_INPUT } from '../../../constants';

const EarlyPayoutSettingsRow = ({
  getMarketName, leagueDetail, hasPermissionToUpdate,
  handleInputChange, errors, idx,
}) => {
  const probabilityThresholdError = errors?.[`probabilityThreshold-${idx}`];
  const minimumSlotError = errors?.[`minimumSlot-${idx}`];

  return (
    <tr
      className={`table-style__row ${leagueDetail?.editted ? 'table-style__row--edited' : ''}`}
    >
      <td>{getMarketName(leagueDetail?.marketId)}</td>
      <td>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={leagueDetail?.enabled}
            onChange={() => handleInputChange(leagueDetail?.marketId, EARLY_PAYOUT_INPUT.CHECKBOX)}
            disabled={!hasPermissionToUpdate}
          />
          <span className="toggle-switch__slider" />
        </label>
      </td>
      <td>

        <input
          className={`table-style__row-input text-center ${probabilityThresholdError ? 'table-style__row-input--error' : ''}`}
          value={leagueDetail?.threshold}
          onChange={(e) => handleInputChange(leagueDetail?.marketId,
            EARLY_PAYOUT_INPUT.THRESHOLD, e.target.value)}
          type="number"
          step="0.01"
          min="0"
          max="1"
          disabled={!hasPermissionToUpdate || !leagueDetail?.enabled}
        />

        {probabilityThresholdError && (
          <div>{probabilityThresholdError}</div>
        )}

      </td>
      <td>
        <input
          className={`table-style__row-input text-center ${minimumSlotError ? 'table-style__row-input--error' : ''}`}
          value={leagueDetail?.minimumSlot || 0}
          onChange={(e) => handleInputChange(leagueDetail?.marketId,
            EARLY_PAYOUT_INPUT.MINIMUM_SLOT, e.target.value)}
          type="number"
          step="1"
          min="0"
          max="90"
          // disabled={!hasPermissionToUpdate || !leagueDetail?.enabled}
          // NOTE: disabled for now because BE part not implemented yet
          disabled
        />

        {minimumSlotError && (
          <div>{minimumSlotError}</div>
        )}

      </td>
    </tr>
  );
};

export default EarlyPayoutSettingsRow;
